import React from 'react'
import {connect} from 'react-redux'

import * as actions from '../../interview/actions'

const MediaBox = ({media, mediaClick}) => {
  let isVideo = (media.split('.').pop()==='mp4')

  return (
    <div className="option-media"
      onClick={mediaClick}
      style={!isVideo ? {backgroundImage: `url(${media})`} : null}>
      {
        isVideo ?
        <video className="option-video" src={media} loop muted autoPlay />
        : null
      }
    </div>
  )
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  mediaClick: (e) => {
    e.stopPropagation()
    dispatch(actions.setActiveImage(ownProps.media))
    return false
  }
})

const MediaBoxContainer = connect(undefined, mapDispatchToProps)(MediaBox)

export {MediaBoxContainer as default, MediaBox}



// WEBPACK FOOTER //
// ./assets/common/components/MediaBox.js